export default "__VITE_ASSET__DTf$ZtSu__"